import * as server from '../../server';
import { LAST_SIX_MONTHS } from '../../constants';
import { getSecondBulkForSixMonthsDates } from '../../helpers';

export const getAllExportTransactions = async ({ period, startDate, endDate, status, type, pageSize }) => {
    let pageId = 0;
    let secondBulk = false;
    let allTransactions = [];

    const getTransactions = async ({ startDate: currentStartDate, endDate: currentEndDate }) => {
        const { data: { transactions, pagingResponseParams: { nextPageId } } } = await server.getTransactionHistory({
            type,
            pageId,
            status,
            pageSize,
            endDate: currentEndDate,
            startDate: currentStartDate
        });

        allTransactions = [...allTransactions, ...transactions];

        if (nextPageId) {
            pageId = nextPageId;

            return getTransactions({ startDate, endDate });
        }

        pageId = null;

        if (!secondBulk && period === LAST_SIX_MONTHS) {
            const { startDate: startDateSecondBulk, endDate: endDateSecondBulk } = getSecondBulkForSixMonthsDates();

            secondBulk = true;

            return getTransactions({ startDate: startDateSecondBulk, endDate: endDateSecondBulk });
        }
    };

    await getTransactions({ startDate, endDate });

    return allTransactions;
};
